<template>
    <div class="m-videoAuth">
        <ul class="tips">
            <li>我们将录制一个时长为 6 ~ 10 秒的视频用于验证</li>
            <li>录制过程中请正面平视摄像头，保证光线充足，不要遮挡面部</li>
        </ul>

        <div class="video-auth" v-if="isSupport">
            <div class="video-header">
                <p v-if="!status">
                    <i class="nucfont inuc-continue"></i>获取摄像头中...
                </p>
                <p v-if="status==='prepared'">
                    <i class="nucfont inuc-continue"></i>已就绪，请开始录制
                </p>
                <p v-if="['recording','canStop'].includes(status)" class="recording">
                    <b :style="{width: (1 - counter/maxCounter)*100 + '%'}"></b>
                    <i class="nucfont inuc-upload-video"></i>录制中，还剩 <span>{{counter}}</span> 秒完成录制
                </p>
                <p v-if="status==='done'" class="done">
                    <i class="nucfont inuc-correct"></i>录制完成，下方视频将用于验证
                </p>
            </div>

            <div class="video-frame">
                <video v-show="status!=='done'" id="recordVideo" width="500" height="375" ref="recordVideo" autoplay></video>

                <canvas id="canvas" width="500" height="375"></canvas>

                <video v-show="status==='done'" width="500" height="375" ref="resultVideo" style="position: relative;" controls loop></video>
            </div>

            <div class="verify-wrap" v-if="verifyStatus">
                <div v-if="verifyStatus==='verifying'" class="verifying">
                    <i class="el-icon-loading"></i>
                    <span>验证中</span>
                </div>
                <p v-if="verifyStatus==='success'">
                    <el-alert
                        title="验证成功"
                        type="success"
                        effect="dark"
                        show-icon>
                    </el-alert>
                </p>
                <div v-if="verifyStatus==='failed'">
                    <el-alert
                        title="验证失败"
                        type="error"
                        effect="dark"
                        :description="`${errorMsg}；请重新录制视频~`"
                        show-icon>
                    </el-alert>
                    <div style="padding: 10px 0;text-align: center;">
                        <el-button @click="reRecord" type="warning" round>重新录制</el-button>
                    </div>
                </div>
            </div>

            <div class="btn-wrap">
                <el-button v-if="status==='prepared'"
                           @click="startRecord" type="primary" round>开始录制
                </el-button>
                <el-button v-if="['recording','canStop'].includes(status)"
                           @click="endRecord" :disabled="status==='recording'" round>结束录制
                </el-button>
            </div>
        </div>

        <div class="not-support" v-else>
            <el-alert
                title="您的浏览器版本不支持该功能"
                type="error"
                description="请使用最新版本Chrome或Firefox浏览器，或者前往移动端完成该活体验证的步骤"
                show-icon>
            </el-alert>
        </div>

        <div class="btn-group">
            <el-button-group>
                <el-button @click="$emit('stepChange', -1)">上一步</el-button>
                <el-button type="success" @click="finishAuth" :disabled="verifyStatus!=='success'">完成认证</el-button>
            </el-button-group>
        </div>

    </div>
</template>

<script>
    import '@/assets/lib/tracking'
    import 'tracking/build/data/face-min'

    export default {
        props: {
            videoStepDone: Boolean,
            active: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                alreadyInit: 0,  // 页面只会初始化一次
                chunks: [],
                stream: null,
                recorder: null,
                status: '',      // 录制的状态：prepared、recording、canStop、done
                verifyStatus: '',    // 验证的状态: verifying、success、failed
                counter: 10,
                maxCounter: 10,
                errorMsg: ''
            }
        },
        computed: {
            video() {
                return this.$refs.recordVideo
            },
            resultVideo() {
                return this.$refs.resultVideo
            },
            isSupport() {
                return navigator.mediaDevices
            }
        },
        mounted() {
        },
        watch: {
            // 仅当第一次进该页面时，初始化一次
            active(v) {
                if (v) {
                    this.alreadyInit++
                    if (this.alreadyInit === 1) {
                        this.initDevice()
                    }
                }
            }
        },
        methods: {
            initDevice() {
                let canvas = document.getElementById('canvas')
                let context = canvas.getContext('2d')

                this.videoTracker = new tracking.ObjectTracker(['face'])
                this.videoTracker.setInitialScale(4)
                this.videoTracker.setStepSize(2)
                this.videoTracker.setEdgesDensity(0.1)

                // 开启摄像头，摄像头开启后开始录像
                this.videoTrackerTask = tracking.track('#recordVideo', this.videoTracker, {
                    camera: true,
                    audio: true,
                    callback: () => {
                        this.status = 'prepared'
                        this.recorder = new MediaRecorder(tracking.stream)

                        this.recorder.ondataavailable = e => {
                            this.chunks.push(e.data);
                        }
                    }
                })

                // 每次捕捉到人脸时在视频上标框
                this.videoTracker.on('track', (event) => {
                    context.clearRect(0, 0, canvas.width, canvas.height)
                    event.data.forEach(function (rect) {
                        context.strokeStyle = '#a64ceb'
                        context.strokeRect(rect.x, rect.y, rect.width, rect.height)
                        context.font = '12px Helvetica'
                        context.fillStyle = "#fff"
                        context.fillText('检测到人脸', rect.x + rect.width + 5, rect.y + 12)
                        context.fillText('x: ' + rect.x + 'px', rect.x + rect.width + 5, rect.y + 30)
                        context.fillText('y: ' + rect.y + 'px', rect.x + rect.width + 5, rect.y + 42)
                    })
                })

            },

            startRecord() {
                this.recorder.start()
                this.status = 'recording'

                clearInterval(this.timeHandler)
                this.timeHandler = setInterval(() => {
                    this.counter--
                    if (this.counter === 4) {
                        this.status = 'canStop'
                    }
                    if (this.counter < 0) {
                        this.status = 'done'
                        this.endRecord()
                        clearInterval(this.timeHandler)
                    }
                }, 1000)

            },
            endRecord() {
                this.recorder.stop()
                this.status = 'done'
                clearInterval(this.timeHandler)

                this.recorder.onstop = e => {
                    this.videoBlob = new Blob(this.chunks, { type: "video/webm" })

                    this.resultVideo.src = window.URL.createObjectURL(this.videoBlob)
                    this.resultVideo.play()

                    // 录完屏之后就关闭摄像头，停止人脸捕捉
                    this.recycleCamera()

                    // 自动上传
                    this.uploadRecord()
                }
            },

            reRecord() {
                this.status = ''
                this.verifyStatus = ''
                this.counter = this.maxCounter

                this.$nextTick(() => {
                    this.videoTrackerTask = tracking.track('#recordVideo', this.videoTracker, { camera: true,
                        callback: () => {
                            this.status = 'prepared'
                            this.recorder = new MediaRecorder(tracking.stream)

                            this.recorder.ondataavailable = e => {
                                this.chunks.push(e.data);
                            }
                        }
                    })
                })
            },

            uploadRecord() {
                let formData = new FormData();
                formData.append('video', this.videoBlob);

                this.verifyStatus = 'verifying'

                this.$api.uploadLivenessVideo(formData).then(res => {
                    this.verifyStatus = 'success'
                    this.$emit('update:videoStepDone', true)
                }).catch(error => {
                    this.errorMsg = error.data.message || ''
                    this.verifyStatus = 'failed'
                })
            },

            recycleCamera() {
                this.chunks = []

                // 停止人脸捕捉
                this.videoTrackerTask && this.videoTrackerTask.stop()

                // 关闭摄像头
                if (tracking.stream) {
                    tracking.stream.getTracks().forEach(track => {
                        track.stop()
                    })
                }
            },

            // 完成认证
            finishAuth() {
                this.$emit('finishAuth')
            },
        },

        beforeDestroy() {
            this.recycleCamera()
        }
    }
</script>

<style lang="scss">
    .m-videoAuth {
        .video-header {
            position: relative;
            height: 36px;
            line-height: 36px;
            background-color: #eee;
            border: 1px solid #ddd;
            border-bottom: none;
            border-radius: 4px 4px 0 4px;

            p {
                padding-left: 20px;
                color: #666;
            }

            .nucfont {
                font-size: 14px;
                margin-right: 5px;
            }

            .recording {
                position: relative;
                background-color: transparent;
                border-color: #e6a23c;
                color: #444;
                z-index: 0;

                b {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    background-color: #e6a23c;
                    z-index: -1;
                    transition: width .5s ease-in-out;
                }

                span {
                    color: #311e00;
                    font-weight: 600;
                }
            }

            .done {
                background-color: #67c23a;
                border-color: #67c23a;
                color: #fff;
            }
        }

        .video-frame {
            position: relative;

            video {
                border: 1px solid #ddd;
                border-top: none;
                outline: none;
                box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
            }

            #canvas {
                position: absolute;
                top: 0;
                left: 0;
            }
        }

        .btn-wrap {
            text-align: center;
            button {
                margin: 20px 0;
            }
        }

        .verify-wrap {
            margin: 20px 0;
            .verifying {
                padding: 10px 0;
                display: flex;
                justify-content: center;
                align-items: center;
                .el-icon-loading {
                    font-size: 20px;
                    color: #444;
                }
                span {
                    margin-left: 5px;
                    font-size: 16px;
                    letter-spacing: 1px;
                    color: #999;
                    font-weight: 600;
                }
            }
        }
    }
</style>
